import { AcademicCapIcon } from "@heroicons/react/solid";

const obj = {
  title:
    "STAAR English I: Informational, Argumentative, or Correspondence - Batch Marking with Word",
  desc: "Use this tool to mark free response essays to STAAR English I constructed response questions. AO1 (‘Organization and Development of Ideas’) out of 3. AO2 (‘Conventions') out of 2.",
  category: "staarengword",
  Icon: AcademicCapIcon,
  // tags: [],
  permissions: ["user"],

  fromColor: "green-400",
  toColor: "green-600",

  to: "/ai/writing/texasengoneword",
  api: "/ai/writing/texasengoneword",

  output: {
    title:
      "STAAR English I: Informational, Argumentative, or Correspondence - Batch Marking with Word",
    desc: "Please wait as we query AI models. This can take up to 2 minutes.",
    // Icon: RefreshIcon,
    // color: "",
  },

  prompts: [
    {
      title:
        "STAAR English I: Informational, Argumentative, or Correspondence - Batch Marking with Word",
      desc: "Enter the candidate's response",
      // n: 1,
      prompts: [
        {
          title: "Essay Title",
          attr: "essay_title",
          value: "",
          placeholder: "Enter the essay title here",
          label: "Essay Title",
          type: "textarea",
          maxLength: 950,
          required: true,
          example:
            "Read the article “Back in Time: The National Road.” Based on the information in the article,\nwrite a response to the following:\nExplain why travelers enjoy using the National Road today.\nWrite a well-organized essay that uses specific evidence from the article to support\nyour answer.\nRemember to —\n• clearly state your thesis\n• organize your writing\n• develop your ideas in detail\n• use evidence from the selection in your response\n• use correct spelling, capitalization, punctuation, and grammar\nManage your time carefully so that you can —\n• review the selection\n• plan your response\n• write your response\n• revise and edit your response\nWrite your response in the box provided.",
        },

        {
          title: "Extract A",
          attr: "extract1",
          value: "",
          placeholder: "Enter the extract here",
          label: "extract1",
          type: "textarea",
          maxLength: 5000,
          required: true,
          error: "",
          example:
            "Back in Time: The National Road \n\nby Rickie Longfellow \n\nThe National Road, in many places known as Route 40, was built between 1811 and 1834 to reach the western settlements. It was the first federally funded road in U.S. history. George Washington and Thomas Jefferson believed that a trans-Appalachian road was necessary for unifying the young country. In 1806 Congress authorized construction of the road and President Jefferson signed the act establishing the National Road. It would connect Cumberland, Maryland, to the Ohio River. \n\nIn 1811 the first contract was awarded and the first 10 miles of road built. By 1818 the road was completed to Wheeling, and mail coaches began using the road. By the 1830s the federal government conveyed part of the road’s responsibility to the states through which it runs. Tollgates and tollhouses were then built by the states, with the federal government taking responsibility for road repairs. \n\nAs work on the road progressed, a settlement pattern developed that is still visible. Original towns and villages are found along the National Road, many barely touched by the passing of time. The road, also called the Cumberland Road, National Pike, and other names, became Main Street in these early settlements, earning the nickname ‘The Main Street of America.’ The height of the National Road’s popularity came in 1825 when it was celebrated in song, story, painting, and poetry. During the 1840s popularity soared again. Travelers and drovers, westward bound, crowded the inns and taverns along the route. Huge Conestoga wagons hauled produce from frontier farms to the East Coast, returning with staples such as coffee and sugar for the western settlements. Thousands moved west in covered wagons, and stagecoaches traveled the road, keeping to regular schedules\n\nIn the 1870s, however, the railroads came, and some of the excitement faded. In 1912 the road became part of the National Old Trails Road, and its popularity returned in the 1920s with the automobile. Federal aid became available for improvements in the road to accommodate the automobile. In 1926 the road became part of US 40 as a coast-to-coast highway. As the interstate system grew throughout America, interest in the National Road again waned. However, now when we want to have a relaxing journey with some history thrown in, we again travel the National Road. Cameras capture old buildings, bridges, and old stone mile markers. Old brick schoolhouses from early years sporadically dot the countryside, and some are found in the small towns on the National Road. Many are still used, some are converted to a private residence, and others stand abandoned. \n\nHistoric stone bridges on the National Road have their own stories to tell as well as reminding us of the craftsmanship of early engineers. The S Bridge, so named because of its design, stands 4 miles east of Old Washington, Ohio. Built in 1828 as part of the National Road, it is a single arch stone structure. This one of four in the state is deteriorated and is now used for only pedestrian traffic. However, the owners of the bridge are attempting to obtain funding for its restoration. The stone Casselman River Bridge still stands east of Grantsville, Maryland. A product of the early 19th-century federal government improvements program along the National Road, the Casselman River Bridge was constructed from 1813 to 1814. Its 80-foot span, the largest of its type in America, connected Cumberland to the Ohio River. In 1933 a new steel bridge joined the banks of the Casselman River. The old stone bridge, partially restored by the State of Maryland in the 1950s, is now the center of Casselman River Bridge State Park\n\nMile markers have been used in Europe for more than 2,000 years, and our European ancestors continued that tradition here in America. These markers tell travelers how far they are from their destination and were an important icon in early National Road travel. As children we saw them and asked our parents what they were. As adults we nostalgically seek them out for photographing. A drive through National Road towns usually reveals one of these markers, such as the one standing by the historic Red Brick Tavern in Lafayette, Ohio. \n\nIn the 1960s Interstate 70, leaving many businesses by the wayside, bypassed Route 40 and much of the National Road. The emphasis was on faster cars and quicker arrival time. We scurry along at a hurried pace today, but when we want to relax, take our time, and see some sights, we once again travel the National Road. The timeless little villages in quiet hamlets and valleys beckon us to small restaurants for a home-cooked meal and a trip back in time to when the pace of life was slower and less stressful.",
        },

        {
          title: "Extract B",
          attr: "extract2",
          value: "",
          placeholder: "Enter the extract here",
          label: "extract2",
          type: "textarea",
          maxLength: 5000,
          required: false,
          error: "",
          example: ".",
        },

        {
          title: "Essay 1 (Upload .docx or .doc).",
          attr: "word_file1",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: true,
          error: "",
        },

        {
          title: "Essay 2 (Upload .docx or .doc).",
          attr: "word_file2",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: true,
          error: "",
        },

        {
          title: "Essay 3 (Upload .docx or .doc).",
          attr: "word_file3",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 4 (Upload .docx or .doc).",
          attr: "word_file4",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 5 (Upload .docx or .doc).",
          attr: "word_file5",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 6 (Upload .docx or .doc).",
          attr: "word_file6",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 7 (Upload .docx or .doc).",
          attr: "word_file7",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 8 (Upload .docx or .doc).",
          attr: "word_file8",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 9 (Upload .docx or .doc).",
          attr: "word_file9",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 10 (Upload .docx or .doc).",
          attr: "word_file10",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },
      ],
      example: {
        output: "", // outputs: [],
        // Icon: RefreshIcon,
        // color: "",
      },
    },
  ],
};

export default obj;
